<template>
    <div class="scanner-container">
        <input id="barCodeInput" v-model="barCodeInput" type="text" autocomplete="off" @keypress="handleKeypress">
    </div>
</template>

<script>
import Util from '@/assets/libs/util.js'
export default {
    name: 'CodeScannerGeneric',
    data () {
        return {
            barCodeInput: '',
            interval: null,
            androidBarCode: '',
            gertecBarcodeInterval: null,
            isTap: Util.isTapMode(),
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false
        }
    },
    mounted () {
        this.startBarcodeScanner()
    },
    beforeDestroy () {
        this.stopBarcodeScanner()
    },
    methods: {
        startBarcodeScanner: function () {
            if (Util.isAndroidMode() && Util.isGertecSk210()) {
                setTimeout(() => {
                    window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
                }, 1000)

                this.gertecBarcodeInterval = setInterval(() => {
                    let readedCode = window.GertecBarcodeReader.getReadedCode()
                    if (readedCode) {
                        this.androidBarCode = readedCode
                        this.emitCode(this.androidBarCode)
                    }
                }, 1000)
            } else if (Util.isAndroidMode()) {
                document.addEventListener('keypress', this.handleAndroidKeypress)
            } else {
                setTimeout(() => {
                    this.startIntervalToReadBarCode()
                }, 500)
            }
        },
        stopBarcodeScanner: function () {
            if (Util.isAndroidMode() && Util.isGertecSk210()) {
                clearInterval(this.gertecBarcodeInterval)
                window.GertecBarcodeReader.stopDecode()
            } else if (Util.isAndroidMode()) {
                document.removeEventListener('keypress', this.handleAndroidKeypress)
            } else {
                clearInterval(this.interval)
            }
            this.interval = null
            this.androidBarCode = ''
            this.gertecBarcodeInterval = null
        },
        handleAndroidKeypress: function (event) {
            if (event.key === 'Enter') {
                this.emitCode(this.androidBarCode)
            } else {
                this.androidBarCode += event.key
            }
        },
        startIntervalToReadBarCode: function () {
            const barCodeInput = document.getElementById('barCodeInput')
            barCodeInput.focus()
            this.interval = setInterval(() => {
                barCodeInput.focus()
            }, 500)
        },
        handleKeypress: function (event) {
            if (event.key === 'Enter') {
                this.emitCode(this.barCodeInput)
                this.barCodeInput = ''
            }
        },
        emitCode: function (barCode) {
            this.$emit('codeScanned', barCode)
            this.barCodeInput = ''
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");
    .scanner-container{
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 50;
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/CodeScannerGeneric.vue